// Base stylesheet needed for every page
import './scss/app.scss';

// import function to register Swiper custom elements
import { register } from 'swiper/element/bundle';
// register Swiper custom elements
register();


//require('../node_modules/bootstrap/js/src/modal.js');
require('./scripts/header');
require('./scripts/navigation');
require('./scripts/slider');
require('./scripts/accordion');
require('./scripts/collection');
require('./scripts/collections-youtube');
require('./scripts/product');
require('./scripts/dropdown');
require('./scripts/search');
require('./scripts/cart');
require('./scripts/filters');
require('./scripts/microcart');
require('./scripts/added-to-cart');
require('./scripts/newsletter');
require('./scripts/quantityControl');
require('./scripts/popup');
require('./scripts/loader');
require('./scripts/language-switcher');
require('./scripts/clSelect');
require('./scripts/reminder');
require('./scripts/video');
require('./scripts/blogs-slider');
require('./scripts/promobar');
require('./scripts/product-slider');
require('./scripts/product-recommendations');
require('./scripts/collection-products-slider');
require('./scripts/upsells');
require('./scripts/sort');
require('./scripts/signature-generator');
require('./scripts/wishlist');
//require('./scripts/cart-discount');
require('./scripts/showcase');
require('./scripts/anchor-link');
require('./scripts/appikon-volume-discounts');
require('./scripts/wakelock');
require('./scripts/combination-deals');
// require('./scripts/geoMessage');
